import DataTableMobileItem from './DataTableMobileItem';
import { IAccountingUser } from '@/interfaces';
import { TEditParams } from '@/hooks/forms/useFormAccountingUser';
import { TCallbackForm } from '@/types';

interface TProps {
    accountingUsers: IAccountingUser[];
    onDelete: (_id: string) => Promise<void>;
    onEdit: (params: TEditParams) => void;
    onSeeDetails: (accountingUser: IAccountingUser, callback?: TCallbackForm<IAccountingUser>) => void;
}

const DataTableMobile = ({ accountingUsers, onDelete, onEdit, onSeeDetails }: TProps) => {

    return (
        <div className="flex flex-col space-y-3">
            {accountingUsers.map((user: IAccountingUser) => (
                <DataTableMobileItem
                    key={user._id}
                    user={user}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onSeeDetails={onSeeDetails} />
            ))}
        </div>
    );
};

export default DataTableMobile;
